var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneIco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.285156,
    y: 0.478516,
    width: 47.5171,
    height: 47.5171,
    fill: "url(#pattern0_778_10582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_778_10582",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_778_10582",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_778_10582",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADFUlEQVR4nO2dTWsUQRCGX1ZQFCXiNRI9ayCiFwX9AQYS74rRs2LyAxT0pmAMEgwkJCFnxXhXjD/AiB4U/LiE5KBn11z8lg6bm7vT3VO1NTv1PlDHpXv6ne6q6q7tAQghhBBCCCGk+7wH8LeDnaMoutwuEGADwD6KoMfJAgGCTVEAPRoAPhcI8AvACYqgx2zELHgFYAdF0OFshADBJiiADrsAfI0QoAngIEXQ4WHkLHhCAXQ4HykAcwMl+gB8jxSAuYESTxNmAXMDBa4kCBByg+ManfBMP4A/CSKsMjeQ52WCAMHGFfrgmuuJAjA3EOZoogDBlqU74Z2PGSLw3ECQuxkChNxgr2QnPHM6Q4Bg96w7Xqczgi8ZAjA3EGQhcxYwNxBiJFOAYNekOuH9jKCZKQBzAyEel5gF4be1YK3NA17qQtsXSwgQbBQ1YKnNw20COKLc9n4AP0oIsF6H3OByhwd8B2CPcvsrJWfBJHqcwwUPuKjc/nhJAWqRG7TzA9s2ptj2QOIZQS1zg3Z+oFv+4HVJAXo+N+jkB7rhD24KCNDTuUGRH9i2eaX2hwQE6PncoMgPeLXN1uy/D2DQ0g/QgN8AZgDstPIDNGyNwYqGCLF+gIatMXgABegHkJQAhgIDUegHkDTDxcsn6QeQJMBbaQHoB5Cc/FEA2AUG4V8/onAJgu0SRCcM2zolhqGwC0PpgJH09k9DGK7/iB785xpbEVz/EbXsTGttxnH9x38H/Vsr2pnS2HqoyoHMMe8HMtZHkre8H0laH8q/8X4ob1mWcsh7WYp1YdaE98Is69LEF95LEy2Lcw8A+Om9ONeyPH2s5Ntfi/J0S5Y9xvxVYXdrmXMX81eFUa8xf1VY9BjzV4UG/6hty5nMt59XFQgxmTH4vKxDkE8ZAvC6GiEGMwafFzYJcoMxvy2riQLw0j5B+nltpS1XPe3zV5FnCQLw6mJh+nh5ty0XGPPb8ihSAH7AwfB6sib3+XUYjnz7+REfJeYiBp+fsVKiwQ+52XKKMb8tdyL2+fkxT0U+cJ+fEEIIIYQQAkf8A5MxbFp/U/HaAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIco2);
export default __webpack_public_path__ + "static/media/PlaneIco-2.b732b3a9900e6fbbc163501681f6efb0.svg";
export { ForwardRef as ReactComponent };